import { Observable, of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ServerTokensService } from '@core/services/server-tokens.service';
import { TranslateLoader } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class TranslateLoaderService implements TranslateLoader, OnDestroy {
    private readonly unsubscribe: Subject<void> = new Subject<void>();

    constructor(private http: HttpClient, private serverTokens: ServerTokensService) {}

    public ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    public getTranslation(): Observable<Translations> {
        if (this.serverTokens.translationsResponse) {
            return of(this.serverTokens.translationsResponse).pipe(takeUntil(this.unsubscribe));
        }
        return this.http.get<Translations>('translations').pipe(takeUntil(this.unsubscribe));
    }
}

export interface Translations {
    [key: string]: string | Translations;
}
